// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2443":"7b47e4ec089f9c24","5165":"0d2aa317027effc7","6458":"bf3b217b7955ee0e"}[chunkId] + ".css";
};